import React from 'react';
import { Row,Col } from "reactstrap";
import moment from "moment";
import userImage from "../../files/user.png";
import doctorImage from "../../files/doctor.png";
import logoImage from "../../files/smarthealth.jpg";
const PatientProfileHeaderPrint = ({ profile, imgStyling, noMargin, latestReadingUser,ccmTotalDuration, rpmTotalDuration, usersViolations, userDetails }) => {
  if (profile) {
    const { fname, lname, isActive, profileImage, email, isCareProvider } = profile;
    const imageDefault = isCareProvider ? doctorImage : userImage;
    const grey = isActive
    ? { ...imgStyling }
    : {
      ...imgStyling,        
      WebkitFilter: "grayscale(100%)",
      filter: "grayscale(100%)"
    };

    function capitalize(cell) {
      if (cell) {
        return cell.charAt(0).toUpperCase() + cell.slice(1);
      }
    }
    return (
        <div className='col-12 remove-table-padding' style={{marginBottom:5}}>
        <div className="text-center">
        <img
          src={logoImage}
          alt="new"
          width="240px"
          className="p-2"
        />
        </div>
          <Row className="mx-auto" style={{ marginTop: 5, marginBottom : 5}}>
            <Col className="notes-pdf-title" md={8} sm={8}>
              <div className="text-left reading-card-for-all-reading float-right">
                <img
                  style={{ borderRadius: '100%', ...grey, marginBottom: 15 }}
                  width={75}
                  height={75}
                  src={profileImage ? process.env.REACT_APP_VIDEO_CALL_REQUEST + "/" + profileImage : imageDefault}
                  className={noMargin ? "" : "mr-2"}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = imageDefault;
                  }}
                  alt="image"
                />
                <div>
                <div className='d-flex align-items-start flex-column gap-4 mb-1'>
                <div className='d-flex mb-1'> 
                <div style={{ textAlign: "start", fontSize: 18 }}> Patient: &nbsp; </div>
                <div style={{ fontWeight: 600, textAlign: "start", fontSize: 18 }}>{`${capitalize(lname)} ${capitalize(fname)}`}</div>
                </div>
                <div className='d-flex mb-1'>
                  <div style={{ textAlign: "start", fontSize: 18 }}>Adherence days : </div>
                  <div style={{ fontWeight: 600, textAlign: "start", fontSize: 18 }}>
                    {"\u00a0\u00a0"}{profile.adhenrenceDay ? profile.adhenrenceDay : 0}
                  </div>
                </div>
                <div className='d-flex mb-1'> 
                <div style={{ fontSize: 18 }}> Care Provider: &nbsp;</div>
                <div style={{ fontWeight: 600, fontSize: 18 }}> {profile && profile.mainCareProvider && profile.mainCareProvider.fname ? profile.mainCareProvider.fname + " " + profile.mainCareProvider.lname : " - "}</div>
                </div>
                <div className='d-flex mb-1'> 
                <div style={{ textAlign: "start", fontSize: 18 }}> Status : &nbsp; </div>
                <div style={{ fontWeight: 600, textAlign: "start", fontSize: 18 }}> 
                {profile.isActive && (
                  <button
                  className="btn btn-info is-active-profile" style={{margin:3}}>
                  Active
                  </button>
                )}
                {!profile.isActive && (
                  <button
                  className="btn btn-info is-in-active-profile" style={{margin:3}}>
                  InActive
                  </button>
                )}</div>
                </div>
                </div>
                </div>
              </div>
            </Col>
            <Col md={4} sm={4} >
            <div className='d-flex flex-column align-items-start' style={{ float: 'right' }}>
            <div className='d-flex mb-1'> 
            <div style={{ fontSize: 18 }}> Phone No: &nbsp; </div>
            <div style={{ fontWeight: 600, fontSize: 18 }}> {profile && profile.phone ? profile.phone : " - "}</div>
            </div>
            <div className='d-flex mb-1'> 
            <div style={{ fontSize: 18 }}> Last Reading : &nbsp;</div>
            <div style={{ fontWeight: 600, fontSize: 18 }}>  {latestReadingUser && latestReadingUser.deviceReadingDate ? moment(latestReadingUser.deviceReadingDate).format("MMMM DD, YYYY") : "NONE"}</div>
            </div>
            <div className='d-flex mb-1'> 
            <div style={{ fontSize: 18 }}> Total RPM : &nbsp; </div>
            <div style={{ fontWeight: 600,fontSize: 18 }}>  {rpmTotalDuration ? rpmTotalDuration : "00:00:00"}</div>
            </div>
            <div className='d-flex mb-1'> 
            <div style={{ fontSize: 18 }}> Total CCM : &nbsp; </div>
            <div style={{ fontWeight: 600, fontSize: 18 }}> {ccmTotalDuration ? ccmTotalDuration : "00:00:00"}</div>
            </div>
            </div>
            </Col>         
          </Row>
        </div>
    );
  }else if(userDetails){
  const { fname, lname, isActive, profileImage, email, isCareProvider } = userDetails;

  const imageDefault = isCareProvider ? doctorImage : userImage;
  const grey = true
  ? { ...imgStyling }
  : {
    ...imgStyling,        
    WebkitFilter: "grayscale(100%)",
    filter: "grayscale(100%)"
  };

  function capitalize(cell) {
    if (cell) {
      return cell.charAt(0).toUpperCase() + cell.slice(1);
    }
  }
  return (
    <div className='col-12 remove-table-padding' style={{marginBottom:5}}>
    <div className="text-center">
    <img
      src={logoImage}
      alt="new"
      width="240px"
      className="p-2"
    />
    </div>
    <Row className="d-flex justify-content-between align-items-start" style={{ margin: '15px 0' }}>
    {/* Left column: Profile info */}
    <Col md={12} style={{ display: 'flex', alignItems: 'center' }}>
      <img
        src={
          profileImage
            ? `${process.env.REACT_APP_VIDEO_CALL_REQUEST}/${profileImage}`
            : imageDefault
        }
        alt="Profile"
        width={60}
        height={60}
        style={{ borderRadius: '50%', marginRight: 15 }}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = imageDefault;
        }}
      />
      <div>
        <div style={{ fontSize: 16 }}>
          <i className="mdi mdi-account-circle" style={{ color: "#607d8b" }}></i>{" "}
          <strong>{userDetails?.isStaff ? 'Staff' : 'Careprovider' }:</strong> {`${capitalize(lname)} ${capitalize(fname)}`}
        </div>
        <div>
          <i className="mdi mdi-domain" style={{ color: "#607d8b" }}></i>{" "}
          <strong>Organization:</strong> {userDetails?.organization || "-"}
        </div>
        <div>
          <i className="mdi mdi-phone" style={{ color: "#607d8b" }}></i>{" "}
          <strong>Phone No:</strong> {userDetails?.phone || "-"}
        </div>
        <div>
          <i className="mdi mdi-email" style={{ color: "#607d8b" }}></i>{" "}
          <strong>Email:</strong> {userDetails?.email || "-"}
        </div>
         {userDetails?.mainCareProvider && (<div>
          <i className="mdi mdi-account" style={{ color: "#607d8b" }}></i>{" "}
          <strong>Main Careprovider:</strong> {userDetails?.mainCareProvider ? userDetails?.mainCareProvider?.fname + " " +  userDetails?.mainCareProvider?.lname  : '-'}
        </div>)}
      </div>
    </Col>
  </Row>
  </div>
  )
  } else {
    return (
      <div >
       
      </div>
    );
  }

};
export default PatientProfileHeaderPrint;